import { toast } from 'react-toastify';
import { catchAsync } from './index.js';

class UserAPIService {
    login = catchAsync(async (email, password) => {
        const res = await fetch(
            `${process.env.REACT_APP_API_URL}/auth/login`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                email: email,
                password: password,
            }),
        });

        const data = await res.json();

        if (!data?.role || data.role !== "admin") {
            throw new Error("Please login with admin credentials.");
        }

        localStorage.setItem("userAdminInfo", JSON.stringify(data));

        return data;
    });

    logout = () => {
        localStorage.removeItem("userAdminInfo");
    }

    getUserToken = () => {
        try {
            const userAuth = localStorage.getItem("userAdminInfo");
            const parsedAuth = JSON.parse(userAuth);

            return parsedAuth?.token;
        } catch (error) {
            toast.error("User Auth Token not found. Please login again.");
            return null;
        }
    }
}

const UserAPI = new UserAPIService();
export default UserAPI;